export default __webpack_public_path__ + "static/miomal-a181cfe47a4b92c7915e06a958ded254.jpg";